import api from "@/services/api/images";

const state = {
  isLoading: false,
  items: [],
  searchQuery: "",
  searchDate: null,
  searchSpecies: [],
  searchAssociation: "all",
  searchOptions: {
    page: 1,
    itemsPerPage: 10,
    sortBy: ["imageNumber"],
    sortDesc: [false],
    multiSort: false,
  },
  total: 0,
};

const getters = {
  loading: (state) => state.isLoading,
  items: (state) => state.items,
  searchQuery: (state) => state.searchQuery,
  searchDate: (state) => state.searchDate,
  searchSpecies: (state) => state.searchSpecies,
  searchAssociation: (state) => state.searchAssociation,
  searchOptions: (state) => state.searchOptions,
  total: (state) => state.total,
};

const actions = {
  async search(
    { commit },
    { query, date, species, association, page, itemsPerPage, sortBy, sortDesc }
  ) {
    commit("loading", { isLoading: true });
    let originalQuery = query;
    let startDate;
    let endDate;

    if (date != null && date.length === 1 && date[0]) {
      startDate = date[0];
      endDate = date[0];
    }
    else if (date != null && date.length > 1) {
      if (date[0] > date[1]) {
        startDate = date[1];
        endDate = date[0];
      }
      else {
        startDate = date[0];
        endDate = date[1];
      }
    }

    const result = await api.search({
      query,
      startDate,
      endDate,
      species,
      unassociatedOnly: association === "unassigned",
      associatedOnly: association === "assigned",
      page,
      itemsPerPage,
      sortBy,
      sortDesc,
    });
    commit("loaded", {
      items: result.data,
      searchQuery: originalQuery,
      searchDate: date,
      searchSpecies: species,
      searchAssociation: association,
      searchOptions: { page, itemsPerPage, sortBy, sortDesc },
      total: result.total,
    });
    commit("loading", { isLoading: false });
  },
  async reload({ dispatch, state }) {
    dispatch("search", {
      query: state.searchQuery,
      date: state.searchDate,
      species: state.searchSpecies,
      association: state.searchAssociation,
      ...state.searchOptions,
    });
  },
};

const mutations = {
  loading(state, { isLoading }) {
    state.isLoading = isLoading;
  },
  loaded(state, { items, searchQuery, searchDate, searchSpecies, searchAssociation, searchOptions, total }) {
    state.searchQuery = searchQuery;
    state.searchDate = searchDate;
    state.searchSpecies = searchSpecies;
    state.searchAssociation = searchAssociation;
    state.searchOptions = { ...searchOptions };
    state.total = total;
    state.items = items;
  },
  setMessage(state, message) {
    state.exportMessage = message;
  },
  exporting(state, exporting) {
    state.exporting = exporting;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
